import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import OthersGroup from "../../../../groups/OthersGroup";

class MetricAvgGuests extends MetricBase {
    constructor() {
        super({
            field: "metric_avgguests",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.avgGuests.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.avgGuests.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.avgGuests.tooltip"),
            group: new OthersGroup(),
        });
    }
}

export default MetricAvgGuests;
